import { ResponsiveTreeMapHtml } from '@nivo/treemap';

import { theme } from '../../theme-dashboard';

export const TreemapChart = ({ data }: { data: any }) => {
  const sortData = (data: any) => {
    if (data.children) {
      data.children = data.children.sort((a: any, b: any) => b.value - a.value);
      data.children.forEach(sortData);
    }
  };

  const sortedData = JSON.parse(JSON.stringify(data));
  sortData(sortedData);

  return (
    <ResponsiveTreeMapHtml
      data={sortedData}
      identity="name"
      value="value"
      valueFormat=".02s"
      margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
      leavesOnly={true}
      innerPadding={3}
      label="id"
      orientLabel={false}
      labelSkipSize={12}
      labelTextColor="text-slate-400"
      nodeOpacity={0.6}
      borderColor={{ theme: 'background' }}
      colors={{ scheme: 'category10' }}
      colorBy="value"
      // colors={theme.tokens.indigo[700]}
      parentLabelPosition="left"
      parentLabelTextColor="text-slate-400"
      theme={theme}
    />
  );
};